import humps from 'humps'
import queryString from 'query-string'
import apiClient from './api-client'

function get(id) {
  return apiClient.get(`notifications/${id}`)
}

function getReasons() {
  return apiClient.get('notifications/reasons')
}

function create(data) {
  return apiClient.post('notifications', humps.decamelizeKeys(data))
}

function list(query) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'notifications',
      query: humps.decamelizeKeys(query),
    }),
    { withHeaders: true },
  )
}

const Notifications = {
  get,
  getReasons,
  create,
  list,
}

export default Notifications
